import { AxiosResponse, AxiosError } from 'axios';

const throwError = (code: number | string, message: string) => {
  throw new Error(`${code}: ${message}`);
};

export const handleError = (error: AxiosError) => {
  return error.response
    ? throwError(
        error.response.status,
        typeof error.response.data === 'string' ? error.response.data : error.response.data.message
      )
    : throwError('Uncaught', error.message);
};

export const oneData = <T>(res: AxiosResponse<T>) => (Array.isArray(res.data) ? res.data[0] : res.data);

export const allData = <T>(res: AxiosResponse<T>) => res.data;

export const getErrorCode = (err: Error) => {
  // get all digits matching within the message
  const extractedCode = err.message.match(/^\d+/g);
  return extractedCode && Number(extractedCode.join(''));
};

export const getErrorMessage = (err: Error, returnFull?: boolean) => {
  const splitMessage = err.message.split(': ');
  if (returnFull) {
    return splitMessage.slice(1, splitMessage.length).join(': ');
  }
  return splitMessage.length > 1 ? splitMessage[1] : splitMessage[0];
};
